module.exports = __webpack_public_path__ + "static/media/avatar3.1d69dc0c.png";